import { Flex } from '@chakra-ui/react';
import React from 'react';
import { Outlet, RouteObject } from 'react-router';

import { Route as LoanAccountsOverviewRoute } from './_index';
import { CollateralAccountsSelectorProvider } from './CollateralAccountsSelectorProvider';
import { Route as HoldingsRoute } from './holdings/_index';
import { Route as SummaryRoute } from './summary/_index';
import { Route as UnderMarginReportRoute } from './under-margin-report/_index';

// Exports
export const Router: RouteObject = {
  element: (
    <CollateralAccountsSelectorProvider>
      <Flex
        direction="column"
        padding={['1.5rem', '1.5rem', '1.5rem', '2.5rem']}
      >
        <Outlet />
      </Flex>
    </CollateralAccountsSelectorProvider>
  ),
  // Relative to /valley-bank/loan-products/*
  children: [
    { index: true, element: <LoanAccountsOverviewRoute /> },
    { path: 'under-margin-report', element: <UnderMarginReportRoute /> },
    { path: 'summary', element: <SummaryRoute /> },
    { path: 'holdings', element: <HoldingsRoute /> },
  ],
};
